export const getFormatMessage = () => {
	return `Email не соответствует формату`;
};
